function fillMaximumMealsPerScreen(meals, numberOfScreens, maxPerScreen) {
  const result = Array(numberOfScreens).fill([])
  if (meals.length == 0 || numberOfScreens == 0 || maxPerScreen == 0) {
    return result
  }
  const quotient = Math.floor(meals.length / maxPerScreen)
  const modulo = meals.length % maxPerScreen
  let i
  for (i = 0; i < quotient && i < numberOfScreens; i++) {
    result[i] = meals.slice(i * maxPerScreen, i * maxPerScreen + maxPerScreen)
  }
  if (i < numberOfScreens) {
    result[i] = meals.slice(i * maxPerScreen, i * maxPerScreen + modulo)
  }
  return result
}

function fillMinimumMealsPerScreen(meals, numberOfScreens, maxPerScreen) {
  const result = Array(numberOfScreens).fill([])
  if (meals.length == 0 || numberOfScreens == 0 || maxPerScreen == 0) {
    return result
  }
  meals = meals.slice(0, numberOfScreens * maxPerScreen)
  const quotient = Math.floor(meals.length / numberOfScreens)
  const modulo = meals.length % numberOfScreens
  if (quotient < 1) {
    for (let i = 0; i < numberOfScreens; i++) {
      result[i] = meals.slice(i, i + 1)
    }
    return result
  }
  let count = 0
  let numberOfAdd = Math.min(quotient, maxPerScreen)
  for (let i = 0; i < numberOfScreens; i++) {
    const fixLasts = i < numberOfScreens - modulo ? 0 : 1
    result[i] = meals.slice(count, count + numberOfAdd + fixLasts)
    count += numberOfAdd + fixLasts
  }
  return result
}

function fillMaximumPerScreenWithEmpty(meals, numberOfScreens, maxPerScreen) {
  const result = fillMaximumMealsPerScreen(meals, numberOfScreens, maxPerScreen)
  for (let i = 0; i < numberOfScreens; i++) {
    if (result[i].length < maxPerScreen) {
      Array(maxPerScreen - result[i].length)
        .fill(null)
        .forEach(item => result[i].push(item))
    }
  }
  return result
}

export default {
  fillMinimumMealsPerScreen,
  fillMaximumMealsPerScreen,
  fillMaximumPerScreenWithEmpty
}
